import { SubjectDataView } from '../person/data';
import { useOrganisationRecord } from './record';

/**
 * **The organisation's raw data** (owner ruling, 2026-09-10: "I notice a lack of
 * a 'Raw data' view for organizations (people have this)").
 *
 * Literally the person view's own reading, over this record's id: `GET
 * /subjects/:id/data` has taken an organisation since chunk 2, and the substrate
 * behind a record is the same substrate whichever kind of subject the record is
 * about.
 *
 * **A route and not a tab**, exactly as a person's is — the owner said so in the
 * same breath ("Remember that it's not a tab - it's a button at the footer"). It
 * is reached from the button in the record's foot, where a power view belongs
 * rather than in the nav the office reads every day, and the shell above it
 * still draws the breadcrumb and the two tabs, so the way back to the
 * organisation is the way back from any other reading of it.
 *
 * It offers no correction link. A person's lineage links across to Research to
 * be corrected; an organisation has no research surface — its lookup writes the
 * summary the Overview opens with — so the line is left off rather than pointing
 * at a page that does not exist.
 */
export function OrganisationDataTab() {
  const { entityId } = useOrganisationRecord();
  return <SubjectDataView subjectId={entityId} correctionHref={null} />;
}
